import PropTypes from 'prop-types';
import styles from './IntegrationTiktokReturnTypeModal.module.scss';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import { tiktokReturnTypes, TiktokReturn } from './tiktokReturnTypes';
import { useDispatch } from 'react-redux';
import { getChannelRedirectUri } from '../../../store/actions/channels';

function IntegrationTiktokReturnTypeModal(props) {
  const { onClose, open, selectedChannel } = props;
  const dispatch = useDispatch();

  const returnTypeButtons = tiktokReturnTypes.map(({ id, value, label, className }) => (
    <Button key={id} id={id} value={value} text={label} onClick={() => handleReturnTypeSelection(value)} />
  ));

  const handleReturnTypeSelection = (returnType) => {
    const managedBySellerReturnType = tiktokReturnTypes.find(
      (returnType) => returnType.value === TiktokReturn.SELLER_MANAGED,
    );
    const tiktokReturnsManagedBySeller = returnType === managedBySellerReturnType.value;

    dispatch(
      getChannelRedirectUri({
        ...selectedChannel,
        additionalUrlQueryParams: { tiktok_returns_managed_by_seller: tiktokReturnsManagedBySeller },
      }),
    );
  };

  return (
    <ModalWindow open={open} onClose={onClose} center>
      <h2>Select Tiktok return type</h2>
      <hr />
      <div className={styles.body}>{returnTypeButtons}</div>
    </ModalWindow>
  );
}

export default IntegrationTiktokReturnTypeModal;

IntegrationTiktokReturnTypeModal.defaultProps = {
  open: false,
};

IntegrationTiktokReturnTypeModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  selectedChannel: PropTypes.object,
};
